export enum TicketingErrors {
  NO_ORDER_REFERENCE = "NO_ORDER_REFERENCE",
  NO_EVENT_ID = "NO_EVENT_ID",
}
